import type { LegalPage as LegalPageData } from "../data/legal";

export function LegalPage({ page }: { page: LegalPageData }) {
  return (
    <main className="page legal-page">
      <h1>{page.title}</h1>
      <p className="legal-summary">{page.summary}</p>
      {page.body.map((text, index) => (
        <p key={index}>{text}</p>
      ))}
      {page.sections.map((section) => (
        <section key={section.heading}>
          <h2>{section.heading}</h2>
          <ul>
            {section.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>
      ))}
      {page.qr && (
        <section className="legal-qr">
          <h2>{page.qr.caption}</h2>
          <img src={page.qr.src} alt={page.qr.caption} width={220} height={220} />
        </section>
      )}
    </main>
  );
}
